<template>
  <div>
    <el-upload :show-file-list="false" :on-success="(file) => handler().imageSuccess(file)" :action="uploadDomain" :data="{ token: qiniuToken }" :before-upload="init().beforeUpload" class="avatar-uploader" >
      <div v-if="value[prop.key]" class="avatar">
        <img :src="value[prop.url]">
        <div class="del btn" @click.stop="value[prop.key] = '';value[prop.url] = ''">
<!--          <i class="icon el-icon-close"/>-->
        </div>
      </div>
      <i v-else class="el-icon-plus avatar-uploader-icon">{{ label }}</i>
    </el-upload>
  </div>
</template>

<script>
import { imgDomain, uploadDomain } from '../../configs/env'
import { getQiniuToken } from '../../api/login';
export default{
  props: {
    label: {
      type: String,
      default: '照片',
    },
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
    prop: {
      type: Object,
      default: () => {
        return {
          key: 'avatar',
          url: 'avatar_url',
        }
      },
    },
  },
  data() {
    return {
      qiniuToken: '',
      imgDomain,
      uploadDomain,
    }
  },
  methods: {
    init() {
      return {
        // 上传前置操作
        beforeUpload: async(file) => {
          var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
          const extension =
            testmsg === "jpg" ||
            testmsg === "JPG" ||
            testmsg === "png" ||
            testmsg === "PNG" ||
            testmsg === "bpm" ||
            testmsg === "jpeg" ||
            testmsg === "JPEG" ||
            testmsg === "gif" ||
            testmsg === "GIF" ||
            testmsg === "BPM";

          if (!extension) {
            this.$message.warning('上传图片只能是jpg /gif / jpeg / gif / png / bpm格式!');
            this.qiniuToken = ''
            return false;
          }
          if (this.qiniuToken) {
            return true
          }
          try {
            // 获取七牛云token
            const { status, data } = await getQiniuToken()
            if (status !== 200) return
            this.qiniuToken = data.token
            return data.token
          } catch (err) {
            this.$message('请求出错')
            return false
          }
        },
      }
    },
    handler() {
      return {
        // 图片上传成功回调
        imageSuccess: (file) => {
          this.$set(this.value, this.prop.url, this.imgDomain + file.key)
          this.$set(this.value, this.prop.key, file.key)
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped >
.avatar-uploader{
  border: 1px dashed #d9d9d9;
  display: block;
  height: 100px;
  width: 100px;
  .avatar-uploader-icon{
    width: 100px;
    height: 100px;
    line-height: 100px;
    font-size: 16px;
  }
  .avatar{
    width: auto;
    height: 100px;
    img{
      width: 100px;
      height: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/uploadImg.vue